import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.webp';

const HeaderContainer = styled.header`
  padding: clamp(0.5rem, 2vw, 1rem);
  text-align: center;
`;

const HeaderTitle = styled(Link)`
  display: inline-block;
  text-decoration: none;

  img {
    width: clamp(200px, 80vw, 421px);
    height: auto;
    max-width: 100%;
    display: block;
    margin: 0 auto;
  }
`;

function Header() {
  return (
    <HeaderContainer className="header">
      <HeaderTitle to="/" className="header-title">
        <img 
          src={logo} 
          alt="Big Brain Logo" 
          width="421" 
          height="112" 
          loading="lazy" 
          decoding="async"
        />
      </HeaderTitle>
    </HeaderContainer>
  );
}

export default Header; 